<div class="text-center mat-bg-primary pt-1 pb-1">
  <h6 class="m-0">NOTIFICAÇÕES</h6>
</div>
<mat-nav-list class="notification-list" role="list">
  <!-- Notification item -->
  <mat-list-item *ngFor="let n of notifications | async" class="notific-item" 
  role="listitem" routerLinkActive="open" >
    <mat-icon [color]="this.getColorByType(n.tipoNotificacao)" class="notific-icon mr-1">{{this.getIconByType(n.tipoNotificacao)}}</mat-icon>
    <a (click)="$event.preventDefault();openPopUp(n)">
      <div class="mat-list-text">
        <h4 class="message"><span *ngIf="n.fromInfokaw" [matTooltip]="'infokaw'"> * </span> {{n.titulo}}</h4>

        <small class="time text-muted">{{n.inicio | date:'dd/MM/yyyy'}}</small>
      </div>
    </a>
  </mat-list-item>
  <mat-list-item *ngIf="this.notificPanel.totalNotif===0" class="notific-item" role="listitem" routerLinkActive="open">
    <mat-icon [color]="'primary'" class="notific-icon mr-1">info</mat-icon>
      <div class="mat-list-text">
        <h4 class="message">Nenhuma Notificação</h4>
      </div>
  </mat-list-item>
</mat-nav-list>
<div class="text-center mt-1" *ngIf="this.notificPanel.totalNotif>0">
  <small><a href="#" (click)="clearAll($event)">{{'CLEAR_NOTIFICATION' | translate}}</a></small>
</div>